import { Injectable } from '@angular/core';

import { AccaBoostFilter, CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostSportsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.Sports;

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const filter = token.filter as AccaBoostFilter;

        return state.selectedPicks.every((pick) => !!filter.sportsConfigs[pick.sportId]);
    }
}
